import instance from "@/utils/require.js"

// --查询扩展字段信息
export function apiSearchOrderExtendConfig(data = {}) {
    return instance({
        url: "/aim/api/v3/order_extend_config/search_order_extend_config",
        method: "post",
        data
    })
}
// -新增扩展字段信息
export function apiAddOrderExtendConfig(data = {}) {
    return instance({
        url: "/aim/api/v3/order_extend_config/add_order_extend_config",
        method: "post",
        data
    })
}
// --修改扩展字段信息
export function apiUpdateOrderExtendConfig(data = {}) {
    return instance({
        url: "/aim/api/v3/order_extend_config/update_order_extend_config",
        method: "post",
        data
    })
}
// --删除组扩展字段信息
export function apiDeleteOrderExtendConfig(data = {}) {
    return instance({
        url: "/aim/api/v3/order_extend_config/delete_order_extend_config",
        method: "post",
        data
    })
}